import Map from '@/components/Map';
import { MapType } from '@/types';
import { Fragment, useCallback, useMemo } from 'react';

const useLayoutRenderer = (layout: any[], componentMap: MapType, componentProps?: MapType) => {
  const renderLayout = useCallback(
    (layoutItem: any, index: number) => {
      const { __component: componentName, id, ...restLayoutItemAttrs } = layoutItem;
      const Component = componentMap[componentName] ?? Fragment;
      const props = Object.assign(restLayoutItemAttrs, componentProps?.[componentName] ?? {});
      return <Component key={'layout-map-' + id + '-' + index} {...props} />;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [componentProps],
  );

  const layoutJSX = useMemo(
    () => <Map list={layout} render={renderLayout} />,
    [layout, renderLayout],
  );

  return layoutJSX;
};

export default useLayoutRenderer;
